import { Directive } from '@angular/core';

@Directive({
    selector: '[appStopPropagation]',
    standalone: false
})
export class StopPropagationDirective {}
